import React, { PureComponent } from "react";
import { Tree } from "antd";
import Icon from "@/components/Icon";
import styles from "./unitTypeTree.module.less";

const { TreeNode } = Tree;
class UnitTypeTree extends PureComponent {
    loop = (data, type) => {
        if (!(data && data.length > 0)) return ``;
        return data.map((item, index) => {
            let key = type ? item.category : item.id;
            let title = type ? item.categoryLabel : item.name
            let children = type ? item.unitList : item.children;
            if (type) {
                let titleSuf = children && children.length ? `(单位:${children.length})` : '';
                if (children && children.length) {
                    return (
                        <TreeNode
                            disabled
                            key={key}
                            title={
                                <span style={{ lineHeight: 1.7 }}>{title}
                                    <span style={{ color: 'rgb(18,150,219)' }}>{titleSuf}</span>
                                </span>
                            }
                            dataRef={item}
                            treeType='unitType'>
                            {children && children.length ? this.loop(children) : ''}
                        </TreeNode>)
                } else {
                    return "";
                }
            } else {
                let titleSuf = `(设备:${item.deviceTotal})`;
                return (
                    <TreeNode
                        key={key}
                        title={
                            <span style={{ lineHeight: 1.7 }}>
                                <Icon.Prop style={{ fontSize: '0.18rem' }} type={"changgui-danwei"} />
                                {title}
                                <span style={{ color: 'rgb(18,150,219)' }}>{titleSuf}</span>
                            </span>
                        }
                        dataRef={item}
                        treeType='unit'>
                    </TreeNode>
                );
            }
        });
    }

    render() {
        const { data, onSelect, value } = this.props;
        let par = {}
        if (value && value.id && value.id.length > 0) {
            par.defaultSelectedKeys = [value.id];
        }
        return (
            <div className={styles.unitTypeTreeDiv}>
                <Tree
                    {...par}
                    onSelect={onSelect}
                >
                    {this.loop(data, true)}
                </Tree>
            </div>
        )
    }
}

export default UnitTypeTree